import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { initErrorLogger } from './utils/errorLogger';
import { register as registerServiceWorker } from './utils/serviceWorkerRegistration';

// Initialize error logging
initErrorLogger();

// Register service worker for offline capability
registerServiceWorker();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
